import React, { useContext, useMemo } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { ChoiceGroup } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withCustomValidation } from '@bingads-webui-react/validation';

import { InfoLabel } from '../info-label';

const getStyles = () =>
  ({
    dateManagementSelectorContainer: {
      '& .ms-ChoiceField': {
        '& .ms-ChoiceField-input': {
          position: 'absolute',
          opacity: 0,
          top: 0,
          right: 0,
          width: '100%',
          height: '100%',
          margin: 0,
        },
        '& .ms-ChoiceField-field': {
          padding: 0,
          marginRight: 8,
          '& .ms-ChoiceFieldLabel': {
            verticalAlign: 'baseline',
            fontWeight: 400,
          },
        },
      },
    },
  });

const DATE_MANAGEMENT_OPTIONS = {
  CampaignLevel: {
    value: 'campaignLevel',
    label: _TL_('Campaign level'),
  },
  AdGroupLevel: {
    value: 'adGroupLevel',
    label: _TL_('Ad group level'),
  },
};

export const DateManagementSelector = (props) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  const {
    value,
    onChange,
    isEnabled,
  } = props;

  const selectionValue = value ? DATE_MANAGEMENT_OPTIONS.CampaignLevel.value : DATE_MANAGEMENT_OPTIONS.AdGroupLevel.value;

  const options = useMemo(() => _.values(DATE_MANAGEMENT_OPTIONS).map(option => ({
    key: option.value,
    text: i18n.getString(option.label),
    ariaLabel: i18n.getString(option.label),
    disabled: !isEnabled,
  })), [i18n, isEnabled]);

  return (
    <div className={classes.dateManagementSelectorContainer}>
      <InfoLabel label={_TL_('Date management')} infoTopic="pop_BA_Campaigns_DateManagement" />
      <ChoiceGroup
        selectedKey={selectionValue}
        options={options}
        onChange={(e, data) => onChange({ UseCampaignLevelDates: data.key === DATE_MANAGEMENT_OPTIONS.CampaignLevel.value })}
      />
    </div>
  );
};

DateManagementSelector.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  isEnabled: PropTypes.bool,
};

DateManagementSelector.defaultProps = {
  value: false,
  isEnabled: true,
};

export const ValidatedDateManagementSelector = withCustomValidation(DateManagementSelector);
